<template>
  <BContainer
    v-if="user"
    fluid
  >
    <div class="d-flex flex-column flex-md-row justify-content-md-between mb-0 pb-0">
      <div
        class="order-2 order-md-1"
      >
        <BButton
          size="sm"
          variant="primary"
          @click.prevent="createRequest"
        >
          Create Order
        </BButton>
      </div>
      <div
        class="order-1 order-md-2 align-self-end mb-3 mb-md-0"
      >
        <BBreadcrumb
          v-if="$route.meta.breadcrumb"
          :items="$route.meta.breadcrumb || []"
        />
      </div>
    </div>

    <BTabs
      v-model="currentTabIndex"
      active-nav-item-class="font-weight-bold text-uppercase text-primary"
      class="mt-3"
    >
      <BTab>
        <template #title>
          <i :class="iconState('fa-file-circle-info', currentTabIndex === 0)" /> Pendings
        </template>
        <RequestPending
          ref="srPending"
          :tab-index="currentTabIndex"
          @show="showRequestPreview"
        />
      </BTab>

      <BTab>
        <template #title>
          <i :class="iconState('fa-file-circle-question', currentTabIndex === 1)" /> Drafts
        </template>
        <RequestDraft
          ref="srDraft"
          :tab-index="currentTabIndex"
          @show="showRequest"
        />
      </BTab>

      <BTab>
        <template #title>
          <i :class="iconState('fa-clock-rotate-left', currentTabIndex === 2)" /> Histories
        </template>
        <RequestHistory
          ref="srHistory"
          :tab-index="currentTabIndex"
          @show="showRequestPreview"
          @edit="showRequest"
        />
      </BTab>
    </BTabs>

    <BModal
      id="modalRequest"
      size="xl"
      scrollable
      centered
      hide-header
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      content-class="scrollable-tabs"
      modal-class="full-height modal-no-padding"
      aria-hidden="false"
      role="dialog"
    >
      <BTabs
        active-nav-item-class="font-weight-bold text-uppercase text-primary"
        content-class="scrollable"
      >
        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i
                :class="['fa-lg fad fa-list-tree', {
                  'text-danger fat fa-shake': vTabStockRequest() || vTabProducts()
                }]"
              />
              <b
                :class="['is-tab-active ml-1', {
                  'text-danger': vTabStockRequest() || vTabProducts()
                }]"
              >
                Products
              </b>
            </div>
          </template>
          <BRow class="mx-0 mt-1 mb-0">
            <BCol
              cols="12"
              md="4"
              class="px-1 px-md-2"
            >
              <ValidationObserver
                ref="formStockRequest"
              >
                <form
                  role="form"
                  novalidate
                  @submit.prevent
                >
                  <BRow>
                    <BCol
                      cols="12"
                      class="px-1 px-md-2"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        vid="headers.origin"
                        name="location"
                        rules="required"
                      >
                        <BFormGroup
                          label="Order To"
                          label-for="fOrigin"
                          label-class="font-weight-bolder"
                          class="mb-2"
                        >
                          <v-select
                            v-model="selected.origin"
                            input-id="fOrigin"
                            label="location_name"
                            placeholder="search location here"
                            :options="options.origins"
                            :class="{ 'is-invalid': errors.length > 0 }"
                            :disabled="fetching.origins"
                            :loading="fetching.origins"
                          >
                            <template #no-options="">
                              no available location
                            </template>
                          </v-select>
                          <div
                            v-if="(errors.length > 0)"
                            class="invalid-feedback"
                            v-text="errors[0]"
                          />
                        </BFormGroup>
                      </ValidationProvider>
                    </BCol>
                  </BRow>
                </form>
              </ValidationObserver>
            </BCol>

            <BCol
              cols="12"
              class="px-0 px-md-1"
            >
              <ValidationObserver
                ref="formProducts"
              >
                <POTable
                  ref="componentProducts"
                  :details="stockRequest.details"
                  :options="options.products"
                />
              </ValidationObserver>
            </BCol>
          </BRow>
        </BTab>
        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i
                :class="['fa-lg fad fa-file-lines', {
                  'text-danger fat fa-shake': vTabDeliveryDetails()
                }]"
              />
              <b
                :class="['is-tab-active ml-1', {
                  'text-danger': vTabDeliveryDetails()
                }]"
              >
                Delivery Details
              </b>
            </div>
          </template>

          <ValidationObserver
            ref="formCustomer"
          >
            <BRow class="mx-0 mt-1 mb-0">
              <BCol
                cols="12"
                class="px-1 px-md-2"
              >
                <BRow>
                  <BCol
                    cols="12"
                    class="px-1 px-md-2"
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      vid="headers.customer_direct"
                      name="customer direct"
                    >
                      <BFormGroup
                        class="mb-1"
                        label-for="fCustomerDirect"
                      >
                        <BFormCheckbox
                          id="fCustomerDirect"
                          v-model="stockRequest.delivery_details.customer_direct"
                          switch
                          value="1"
                          name="headers.customer_direct"
                          unchecked-value="0"
                          :disabled="busy"
                        >
                          <strong>Direct Delivery to Customer?</strong>
                        </BFormCheckbox>

                        <div
                          v-if="(errors.length > 0)"
                          class="invalid-feedback"
                          v-text="errors[0]"
                        />
                      </BFormGroup>
                    </ValidationProvider>
                  </BCol>
                  <BCol
                    cols="12"
                    md="3"
                    class="px-1 px-md-2"
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      vid="delivery_details.mobile_number"
                      name="mobile number"
                      rules="required_if:headers.customer_direct,1|max:11"
                    >
                      <BFormGroup
                        label="Mobile Number"
                        label-for="fScheduleMobile"
                        label-class="font-weight-bolder"
                        class="mb-2"
                      >
                        <BFormInput
                          id="fScheduleMobile"
                          v-model="stockRequest.delivery_details.mobile_number"
                          v-mask="'0##########'"
                          type="text"
                          maxlength="11"
                          placeholder="enter mobile number here"
                          :state="(errors.length > 0 ? false : null)"
                          :disabled="busy || Number(stockRequest.delivery_details.customer_direct) === 0"
                        />
                        <div
                          v-if="(errors.length > 0)"
                          class="invalid-feedback"
                          v-text="errors[0]"
                        />
                      </BFormGroup>
                    </ValidationProvider>
                  </BCol>

                  <BCol
                    cols="12"
                    md="9"
                    class="px-1 px-md-2"
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      vid="delivery_details.customer"
                      name="customer name"
                      rules="required_if:headers.customer_direct,1|max:255"
                    >
                      <BFormGroup
                        label="Customer Name"
                        label-for="fCustomerName"
                        label-class="font-weight-bolder"
                        class="mb-2"
                      >
                        <BFormInput
                          id="fCustomerName"
                          v-model="stockRequest.delivery_details.customer"
                          type="text"
                          max-length="255"
                          placeholder="enter customer name here"
                          :state="(errors.length > 0 ? false : null)"
                          :disabled="(busy || Number(stockRequest.delivery_details.customer_direct) === 0)"
                        />

                        <div
                          v-if="(errors.length > 0)"
                          class="invalid-feedback"
                          v-text="errors[0]"
                        />
                      </BFormGroup>
                    </ValidationProvider>
                  </BCol>

                  <BCol
                    cols="12"
                    class="px-1 px-md-2"
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      vid="headers.address"
                      name="address"
                      rules="required_if:headers.customer_direct,1|max:255"
                    >
                      <BFormGroup
                        class="mb-2"
                      >
                        <label
                          for="fCustomerAddress"
                          class="d-flex justify-content-between"
                        >
                          <b>Customer Address</b>
                          <span>
                            {{ stockRequest.delivery_details.address ? stockRequest.delivery_details.address.length : 0 }} / 255
                          </span>
                        </label>
                        <BTextarea
                          id="fCustomerAddress"
                          v-model="stockRequest.delivery_details.address"
                          rows="4"
                          max-rows="6"
                          maxlength="255"
                          placeholder="enter customer address here"
                          :state="(errors.length > 0 ? false : null)"
                          :disabled="(busy || Number(stockRequest.delivery_details.customer_direct) === 0)"
                        />

                        <div
                          v-if="(errors.length > 0)"
                          class="invalid-feedback"
                          v-text="errors[0]"
                        />
                      </BFormGroup>
                    </ValidationProvider>
                  </BCol>

                </BRow>
              </BCol>
            </BRow>
          </ValidationObserver>
        </BTab>
      </BTabs>
      <template #modal-footer="{ cancel }">
        <div class="pb-0 d-flex justify-content-between mb-0 px-0 flex-grow-1 gap-2">
          <div>
            <BButton
              v-if="editAsDraft"
              variant="secondary"
              size="sm"
              tabindex="-1"
              @click.prevent="validateRequestAsDraft"
            >
              {{ SubmitRequestAsDraftButton }}
            </BButton>
          </div>
          <div class="d-flex gap-2">
            <BButton
              variant="primary"
              size="sm"
              tabindex="-1"
              @click.prevent="validateRequest"
            >
              Submit <span class="d-none d-md-inline-block">Order</span>
            </BButton>
            <BButton
              variant="outline-dark"
              size="sm"
              tabindex="-1"
              @click.prevent="$event => {
                $event.target.blur()
                cancel()
              }"
            >
              Discard
            </BButton>
          </div>
        </div>
      </template>
    </BModal>

    <BModal
      id="modalRequestPreview"
      size="xl"
      scrollable
      centered
      hide-header
      no-enforce-focus
      no-close-on-backdrop
      content-class="scrollable-tabs"
      modal-class="full-height modal-no-padding"
      aria-hidden="false"
      role="dialog"
    >
      <BTabs
        active-nav-item-class="font-weight-bold text-uppercase text-primary"
        content-class="scrollable"
      >
        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-list-tree mr-1" />
              <b class="is-tab-active">Products</b>
            </div>
          </template>
          <BRow class="mx-0 mt-1 mb-0">
            <BCol
              cols="12"
              class="px-1 px-md-2"
            >
              <BRow>
                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Transaction Number"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.references.transaction_number"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Ordered To"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.headers.origin_name"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Group"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.headers.group_name"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Remarks"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.remarks || 'no remarks'"
                    />
                  </BFormGroup>
                </BCol>

              </BRow>
            </BCol>

            <BCol
              cols="12"
              class="px-0 px-md-1"
            >
              <BTable
                ref="tableProducts"
                small
                hover
                striped
                bordered
                responsive
                show-empty
                class="mb-0"
                :stacked="tableProducts.stacked"
                :items="stockRequest.details"
                :fields="tableProducts.fields"
                :filter="tableProducts.filter"
                :filter-included-fields="tableProducts.filterOn"
                :busy="tableProducts.busy"
              >
                <template #cell(index)="{ index }">
                  <div
                    class="text-md-nowrap d-flex justify-content-center align-items-centermin-h-35px"
                    v-text="tableRowNumber(tableProducts, index)"
                  />
                </template>

                <template #cell(product_name)="{ value }">
                  <div class="text-md-nowrap d-flex align-items-center min-h-35px px-1">
                    <span
                      v-text="value"
                    />
                  </div>
                </template>

                <template #cell(quantity)="{ value }">
                  <div class="text-md-nowrap d-flex justify-content-center align-items-center min-h-35px">
                    <strong
                      class="font-weight-bolder"
                      v-text="numberFormatter(value, '0,0')"
                    />
                  </div>
                </template>

                <template #cell(approved_quantity)="{ value, item }">
                  <div class="text-md-nowrap d-flex justify-content-center align-items-center min-h-35px">
                    <strong
                      :class="['font-weight-bolder', {
                        'text-danger': Number(value) <= 0,
                        'text-warning': Number(value) >= 1 && Number(item.quantity) !== Number(value),
                        'text-success': Number(item.quantity) === Number(value)
                      }]"
                      v-text="numberFormatter(value, '0,0')"
                    />
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center py-5">
                    <BIcon
                      icon="stopwatch"
                      font-scale="5"
                      animation="cylon"
                    />
                    <p class="h3 py-2">
                      <strong>Loading . . .</strong>
                    </p>
                  </div>
                </template>

              </BTable>
            </BCol>
          </BRow>
        </BTab>

        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-file-lines mr-1" />
              <b class="is-tab-active">Delivery Details</b>
            </div>
          </template>
          <BRow class="mx-0 mt-1 mb-0">
            <BCol
              cols="12"
              class="px-1 px-md-2"
            >
              <BRow>
                <BCol
                  cols="12"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label-for="fCustomerDirect"
                    class="mb-1"
                  >
                    <BFormCheckbox
                      id="fCustomerDirect"
                      v-model="stockRequest.delivery_details.customer_direct"
                      switch
                      value="1"
                      name="customer_direct"
                      unchecked-value="0"
                      disabled
                    >
                      <strong>Direct Deliver to Customer?</strong>
                    </BFormCheckbox>
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Mobile Number"
                    label-for="fvCustomerMobile"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvCustomerMobile"
                      v-model="stockRequest.delivery_details.mobile_number"
                      type="text"
                      placeholder="no customer mobile"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="9"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Name"
                    label-for="fvCustomerName"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvCustomerName"
                      v-model="stockRequest.delivery_details.customer"
                      type="text"
                      placeholder="no customer name"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Address"
                    label-for="fvCustomerAddress"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BTextarea
                      id="fvCustomerAddress"
                      v-model="stockRequest.delivery_details.address"
                      rows="4"
                      max-rows="6"
                      maxlength="50"
                      placeholder="no customer address"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

              </BRow>
            </BCol>
          </BRow>
        </BTab>

        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-calendar-range mr-1" />
              <b class="is-tab-active ml-1">Delivery Schedule</b>
            </div>
          </template>
          <BRow class="mx-0 mt-1 mb-0">
            <BCol
              cols="12"
              class="px-1 px-md-2"
            >
              <BRow>

                <BCol
                  cols="12"
                  md="4"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Delivery Date"
                    label-for="fvScheduleDate"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleDate"
                      v-model="stockRequest.schedule_details.date"
                      type="date"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="5"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Driver"
                    label-for="fvScheduleDriver"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleDriver"
                      v-model="stockRequest.schedule_details.driver_name"
                      type="text"
                      maxlength="50"
                      placeholder="no driver"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Mobile Number"
                    label-for="fvScheduleMobile"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleMobile"
                      v-model="stockRequest.schedule_details.mobile_number"
                      type="text"
                      maxlength="50"
                      placeholder="no mobile number"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="4"
                  class="px-1 px-md-2"
                />

                <BCol
                  cols="12"
                  md="8"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Helper"
                    label-for="fvScheduleHelper"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleHelper"
                      v-model="stockRequest.schedule_details.helper"
                      type="text"
                      maxlength="50"
                      placeholder="no helper"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="4"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Vehicle Plate"
                    label-for="fvScheduleVehiclePlate"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleVehiclePlate"
                      v-model="stockRequest.schedule_details.vehicle_plate"
                      type="text"
                      maxlength="25"
                      placeholder="no vehicle plate"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="8"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Vehicle Name"
                    label-for="fvScheduleVehicleName"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleVehicleName"
                      v-model="stockRequest.schedule_details.vehicle_name"
                      type="text"
                      maxlength="50"
                      placeholder="no helper"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

              </BRow>
            </BCol>
          </BRow>
        </BTab>

        <BTab class="p-2 py-4">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-timeline-arrow mr-1" />
              <b class="is-tab-active ml-1">Tracking</b>
            </div>
          </template>

          <BContainer>
            <Timeline
              :stock-request="stockRequest"
            >
              <template #approvals="request">
                <Signatory
                  :stock-request="request"
                  :approver="requesterSignatory"
                />
                <Signatory
                  v-if="['Canceled'].includes(canceledSignatory.status)"
                  :stock-request="request"
                  :approver="canceledSignatory"
                />
                <Signatory
                  v-for="(approver, key) in request.approvals"
                  :key="key"
                  :stock-request="request"
                  :approver="approver"
                />
              </template>
            </Timeline>
          </BContainer>
        </BTab>

      </BTabs>
      <template #modal-footer="{ cancel }">
        <div class="col-12 pb-0 d-flex justify-content-end mb-0 px-0">
          <div>
            <BButton
              variant="outline-dark"
              size="sm"
              tabindex="-1"
              @click.prevent="$event => {
                $event.target.blur()
                cancel()
              }"
            >
              Close <span class="d-none d-md-inline-block">Window</span>
            </BButton>
          </div>
        </div>
      </template>
    </BModal>

  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'

import MProducts from '@/mixins/maintenances/products'
import MOrigins from '@/mixins/locations/origins'

import MCreate from '@/views/user/ro/purchase-orders/requests/mixins/create'
import MDraft from '@/views/user/ro/purchase-orders/requests/mixins/draft'
import MPreview from '@/views/user/ro/purchase-orders/requests/mixins/preview'

import RequestPending from '@/views/user/ro/purchase-orders/requests/Pending.vue'
import RequestDraft from '@/views/user/ro/purchase-orders/requests/Draft.vue'
import RequestHistory from '@/views/user/ro/purchase-orders/requests/History.vue'

import POTable from '@/components/tables/POTable.vue'

import Timeline from '@/components/custom/timeline/Base.vue'
import Signatory from '@/components/custom/timeline/Signatory.vue'

export default {

  name: 'VROPORequest',

  middleware: ['auth', 'ro'],

  metaInfo: () => ({
    title: 'Purchase Order - Requests'
  }),

  components: {
    RequestPending,
    RequestDraft,
    RequestHistory,
    POTable,
    Timeline,
    Signatory
  },

  mixins: [
    MISC,
    FORMATTER,
    MProducts,
    MOrigins,
    MCreate,
    MDraft,
    MPreview
  ],

  data () {
    return {
      busy: false,
      editing: false,
      editAsDraft: true,
      currentTabIndex: this.getCurrentTabIndexByURL(),
      selected: {
        locationType: 'Warehouse',
        allowIn: '',
        allowOut: 1,
        allowPO: 1
      },
      stockRequest: {
        id: '',
        stage: 0,
        references: {
          document_number: '',
          transfer_number: '',
          sap_doc_entry: '',
          transaction_number: ''
        },
        headers: {
          group: '',
          group_name: '',
          group_code: '',
          origin: '',
          origin_name: '',
          origin_code: ''
        },
        delivery_details: {
          customer_direct: 0,
          customer: '',
          mobile_number: '',
          address: ''
        },
        schedule_details: {
          date: '',
          vehicle: '',
          vehicle_plate: '',
          vehicle_name: '',
          driver: '',
          driver_name: '',
          mobile_number: '',
          helper: ''
        },
        details: [],
        approvals: [],
        created_at: ''
      },
      tableProducts: {
        selected: {
          details: [],
          allSelected: false,
          indeterminate: false
        },
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: this.isMobile(),
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 1, key: 'product_name', class: 'min-w-200px' },
          { mobile: 2, key: 'quantity', class: ['text-center', { 'col-2': !this.isMobile() }] },
          { mobile: 3, key: 'approved_quantity', label: 'Approved', class: ['text-center', { 'col-2': !this.isMobile() }] }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },

  watch: {

    'selected.origin' (origin) {
      this.stockRequest.headers.origin = origin?.id || ''
      this.stockRequest.headers.origin_code = origin?.location_code || ''
      this.stockRequest.headers.origin_name = origin?.location_name || ''
    },

    'stockRequest.delivery_details.customer_direct' (customerDirect) {
      if (Number(customerDirect) === 0) {
        this.stockRequest.delivery_details.customer = ''
        this.stockRequest.delivery_details.mobile_number = ''
        this.stockRequest.delivery_details.address = ''
      }
    }
  },

  methods: {

    getCurrentTabIndexByURL () {
      switch (this.$route.params.requester) {
        case 'histories' : {
          return 2
        }
        case 'drafts' : {
          return 1
        }
        default: {
          return 0
        }
      }
    },

    validateRequest () {
      this.$refs.formStockRequest.validate().then(
        validStockRequest => {
          this.$refs.formProducts.validate().then(
            validProduct => {
              this.$refs.formCustomer.validate().then(
                validCustomer => {
                  if (!validStockRequest || !validProduct || !validCustomer) {
                    return this.swalInvalid()
                  }

                  this.swalConfirmWithRemarks({
                    html: () => {
                      if (this.editing && this.editAsDraft) {
                        return 'Submit Draft as Purchase Order?'
                      }

                      return 'Submit Purchase Order?'
                    },
                    remarksRequired: true,
                    remarksMaxLength: 220,
                    preConfirm: remarks => {
                      if (this.editing && this.editAsDraft) {
                        return this.updateDraft(0, remarks)
                      }

                      return this.submitRequest(remarks)
                    },
                    confirmButtonText: 'Submit'
                  })
                }
              )
            })
        })
    },

    setProductErrors (errors) {
      const mappedErrors = {}

      Object.keys(errors).forEach(error => {
        const splitted = error.split('.')
        if (splitted.length > 0) {
          const productFields = [
            'category_code',
            'category_name',
            'product_code',
            'product_name',
            'group_code',
            'group_name'
          ]
          if (splitted[0] === 'details' && productFields.includes(splitted[splitted.length - 1])) {
            mappedErrors[`details.${splitted[1]}.product`] = errors[error]
          } else {
            mappedErrors[error] = errors[error]
          }
        }
      })

      this.$refs.formProducts.setErrors(mappedErrors)
    }
  }
}
</script>
